import { JsonBodyRemarkPlugin } from './markdown-plugins-utils.js';
import { OcsTableMarkdownItem } from './ocs-table-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/** Directive name used in markdown container blocks: `:::ocs-table` */
export const OCS_TABLE_DIRECTIVE = 'ocs-table';

/**
 * Remark plugin definition for the `ocs-table` container directive.
 *
 * Usage in markdown:
 * ```
 * :::ocs-table
 * [JSON array]
 * :::
 * ```
 *
 * The directive body is parsed as JSON and passed to {@link OcsTableMarkdownItem}
 * via the `jsonData` prop.
 */
export const ocsTableDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['jsonData'],
	directive: JsonBodyRemarkPlugin(OCS_TABLE_DIRECTIVE),
	item: OcsTableMarkdownItem,
};
